import { CSSProperties, ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface ModalStyleProps {
  height?: number;
  borderColor?: string;
  children?: ReactNode;
}

export const ModalStyle = styled.div<ModalStyleProps>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  background-color: #e4e4e4;
  border-radius: 0;
  overflow: hidden;
  min-width: 320px;
  margin: 0px;

  &.ReactModal__Content {
    border: ${({ theme }) => `1px solid ${theme.palette.neutral.lightest}`};
    color: ${({ theme }) => theme.palette.text.primary};
    opacity: 0;
    transform: translateX(-100px);
    transition: all 500ms ease-in-out;

    ${({ height }) =>
      height &&
      css`
        height: ${height}px;
      `}

    ${({ borderColor }) =>
      borderColor &&
      css`
        border-color: ${borderColor};
      `}
  }

  &.ReactModal__Content--after-open {
    opacity: 1;
    transform: translateY(0px);
  }

  &.ReactModal__Content--before-close {
    opacity: 0;
    transform: translateX(-100px);
  }

  &:focus-visible {
    outline: none;
  }
`;

interface OverlayStyleProps {
  children?: ReactNode;
}

export const OverlayStyle = styled.div<OverlayStyleProps>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3500;
  background: rgba(0, 0, 0, 0.5);

  &.ReactModal__Overlay {
    opacity: 0;
    transition: opacity 300ms ease-in-out;
  }

  &.ReactModal__Overlay--after-open {
    opacity: 1;
  }

  &.ReactModal__Overlay--before-close {
    opacity: 0;
  }
`;

interface ModalDialogWrapperProps {
  children?: ReactNode;
  style?: CSSProperties;
}

export const ModalDialogWrapper = styled.div<ModalDialogWrapperProps>`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  position: relative;
  max-height: 95vh;
`;
